import { toRefs, computed } from 'vue';
import { useButton } from '../button/component-lib.esm.js';
import CircularLoader from '../circular-loader/component-lib.esm.js';
import { getThemeAccentColor, getThemeColor, getThemeTextColor } from '../../styles/theme/component-lib.esm.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { colors } from '../../styles/component-lib.esm.js';

//
var script = {
  components: {
    CircularLoader
  },
  name: 'IconButton',
  props: {
    component: {
      type: String,
      default: 'button'
    },
    size: {
      type: String,
      default: 'medium'
    },
    color: {
      type: String,
      default: 'primary'
    },
    filled: Boolean,
    loading: Boolean,
    disabled: Boolean
  },
  setup(props, _ref) {
    let {
      attrs
    } = _ref;
    const {
      component,
      disabled,
      color,
      size,
      loading,
      filled: isFilled
    } = toRefs(props);
    const theme = useTheme();
    const {
      buttonTag,
      buttonType
    } = useButton({
      component,
      ...attrs
    });
    let iconSize = computed(() => {
      if (theme.value.sizes[size.value]) return `${theme.value.sizes[size.value]}rem`;
      return size.value;
    });
    const classes = computed(() => {
      return {
        'v-icon-btn--loading': loading.value,
        'v-icon-btn--filled': isFilled.value
      };
    });
    const styles = computed(() => {
      let disabledVars = {};
      if (disabled.value || loading.value) {
        disabledVars = {
          '--c-disabled-color': colors.blackLight,
          '--c-disabled-bg-color': colors.gray
        };
      }
      return {
        '--c-bg-color': getThemeAccentColor({
          color: color.value,
          theme: theme.value,
          isFilled: isFilled.value
        }, {
          level: 0
        }),
        '--c-bg-color-active': getThemeAccentColor({
          color: color.value,
          theme: theme.value,
          isFilled: isFilled.value
        }, {
          level: 1
        }),
        '--c-color': getThemeColor(color.value, theme.value),
        '--c-active-color': getThemeTextColor(color.value, theme.value),
        '--c-size': iconSize.value,
        ...disabledVars
      };
    });
    return {
      buttonTag,
      buttonType,
      classes,
      styles
    };
  }
};
export { script as default };